import Vue from 'vue';
import Component from 'vue-class-component';
import OrderListContainer from '@/components/OrderListContainer/OrderListContainer';
import { Order } from '@/types/order';

@Component({
    components: {
        OrderListContainer
    }
})
export default class Orders extends Vue {
}